import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// External Components
import { PageNotFoundComponent } from './views/external/page-not-found/page-not-found.component';
import { NotSupportedBrowserComponent } from './views/external/not-supported-browser/not-supported-browser.component';

import { AnotherInstanceComponent } from './views/external/another-instance/another-instance.component';
import { BrowserSupportGuard, AuthGuard, PermissionGuard } from '@leversys/leversys-frontend-core';

import { WorkspacePanelComponent } from '@leversys/leversys-frontend-core';
import { WorkspaceContentComponent } from '@leversys/leversys-frontend-core';
import { ExternalValuationQueryInstrumentViewComponent } from '@leversys/leversys-frontend-core';
import { ExternalInstrumentViewComponent } from '@leversys/leversys-frontend-core';
import { SettingsComponent } from '@leversys/leversys-frontend-core';
import { InternalComponent } from '@leversys/leversys-frontend-core';

const routes: Routes = [{
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  }, {
    path: 'dashboard',
    // loadChildren: './views/internal/internal.module#InternalModule',
    // canLoad: [BrowserSupportGuard, AuthGuard]
    component: InternalComponent,
    canActivate: [BrowserSupportGuard, AuthGuard],
    children: [{
      path: '',
      pathMatch: 'full',
      redirectTo: 'workspaces'
    }, {
      path: 'workspaces',
      component: WorkspacePanelComponent,
      children: [{
        path: ':id',
        component: WorkspaceContentComponent,
        data: {
          shouldReuse: true,
          routeId: 'workspace-content'
        }
      }],
      canActivate: [PermissionGuard]
    }, {
      path: 'settings',
      component: SettingsComponent,
      canActivate: [PermissionGuard]
    },
    {
      path: 'external-instrument/:id/:instSource',
      component: ExternalInstrumentViewComponent,
      canActivate: [PermissionGuard]
    },
    {
      path: 'external-instrument/:id',
      component: ExternalInstrumentViewComponent,
      canActivate: [PermissionGuard]
    },
    {
      path: 'external-valuation-query-instrument/:instType/:id',
      component: ExternalValuationQueryInstrumentViewComponent,
      canActivate: [PermissionGuard]
    }]
  }, {
    path: 'not-supported-browser',
    component: NotSupportedBrowserComponent
  },
  {
    path: 'another-instance',
    component: AnotherInstanceComponent
  }, {
    path: '**',
    component: PageNotFoundComponent,
    canActivate: [BrowserSupportGuard] // has to be last route, otherwise it would mask below routes
  }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: []
})

export class AppRoutingModule {
}
